import { ConversationChannel } from '@ekhodealer/ekho-common';

/**
 * Placeholder string for empty or loading states
 */
export const PLACEHOLDER = '--';

const CHANNEL_LABELS: Record<string, string> = {
	sms: 'SMS',
	[ConversationChannel.WebChat]: 'Web Chat',
};

/**
 * Formats a conversation channel key into a human-readable label.
 * Falls back to the raw channel value for unknown keys.
 */
export function formatChannelLabel(channel: string): string {
	return CHANNEL_LABELS[channel] ?? channel;
}

/**
 * Formats an array of conversation channels into a comma-separated label.
 * e.g. ['sms', 'web_chat'] → 'SMS, Web Chat'
 */
export function formatChannelLabels(channels: string[] | undefined): string {
	if (!channels?.length) return '';
	return channels.map(formatChannelLabel).join(', ');
}

/**
 * Capitalizes the first letter of a string
 * @param string - The string to capitalize
 * @returns The capitalized string
 */
export function capitalizeFirstLetter(string: string): string {
	return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

/**
 * Parses a service name by capitalizing words and converting underscores to spaces
 * Example: "coverage_tax" -> "Coverage Tax", "assembly" -> "Assembly"
 */
export function parseServiceName(service: string): string {
	return service
		.split('_')
		.map((word) => capitalizeFirstLetter(word.toLowerCase()))
		.join(' ');
}

/**
 * Converts an enum value to sentence case by replacing underscores with spaces
 * and capitalizing only the first letter
 * Example: "NEW_LEAD" -> "New lead", "CONTACTED" -> "Contacted"
 */
export function toSentenceCase(value: string): string {
	return value
		.replace(/_/g, ' ')
		.toLowerCase()
		.replace(/^\w/, (c) => c.toUpperCase());
}
